//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import LoginPane from './components/LoginPane.vue';
import localeMixin from '@/locales/mixin.js';
import SettingHost from './components/setting-host/index';
export default {
  mixins: [localeMixin],
  components: {
    LoginPane: LoginPane,
    SettingHost: SettingHost
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      setTimeout(function () {
        var loginBar = document.querySelector('.login-bar');
        loginBar.style.width = 460 + 'px';
        setTimeout(function () {
          var title = document.querySelector('.title-wrap');
          title.style.visibility = 'visible';
          title.style.opacity = 1;
        }, 300);
      }, 500);
    });
  }
};